const state = {
  first_name: null,
  title: null,
  phone: null,
  email: null
};

const getters = {
  getFirstName: state => state.first_name,
  getTitle: state => state.title,
  getPhone: state => state.phone,
  getEmail: state => state.email
};

const mutations = {
  setFirstName(state, first_name) {
    state.first_name = first_name;
  },
  setTitle(state, title) {
    state.title = title;
  },
  setPhone(state, phone) {
    state.phone = phone;
  },
  setEmail(state, email) {
    state.email = email;
  }
};

const actions = {
  saveFirstName({ commit }, first_name) {},
  saveTitle({ commit }, title) {
    commit("setTitle", title);
  },
  savePhone({ commit }, phone) {},
  saveEmail({ commit }, email) {}
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
